module.exports = new __parcel__URL__("issues-highlight.37797bd0.svg").toString();